import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Social' })((theme) => ({
    root: {
        padding: 24,
        marginBottom: 24,
        marginRight: 24,
        borderRadius: 28,
        height: 418,
        border: '1px solid #EEEEEE',
        display: 'flex',
        flexDirection: 'column',
        '@media (max-width: 720px)': {
            marginRight: 0
        }
    },
    title: {
        fontWeight: 700,
        fontSize: 24
    },
    description: {
        fontSize: 14
    },
    fullList: {
        color: theme.palette.primary.main,
        fontWeight: 600
    },
    chart: {
        flex: 1
    }
}));
